import {CtModelRouteData} from "@ctsolution/ct-framework";

export const HandlingRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("handling");

export const TimelineHandlingRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("timelinehandling");
